import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import WorkDoneAreas from '../components/WorkDoneAreas';

const WhereWeWork = ({ darkMode }) => {
    const cardStyle = {
        backgroundColor: darkMode ? '#343a40' : '#ffffff',
        color: darkMode ? '#f8f9fa' : '#212529',
        border: darkMode ? '1px solid #495057' : '1px solid #dee2e6'
    };

    return (
        <Container style={{ minHeight: '100vh', paddingTop: '30px', paddingBottom: '30px' }}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h2 className="text-center mb-3" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                    Where We Work
                </h2>
                <p className="text-center mb-2" style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.1rem' }}>
                    PSGS operates across 13 districts of Maharashtra, reaching more than 3,869 villages.
                    Our primary area of intervention is Sangli District, with extended reach through
                    capacity building interventions including Goa for Jal Jeevan Mission.
                </p>
            </motion.div>

            <Row className="mb-3">
                <Col md={12}>
                    <Card style={cardStyle} className="shadow">
                        <Card.Body>
                            <h4 className="text-center mb-1" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                                Project Intervention Area
                            </h4>
                            <WorkDoneAreas />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default WhereWeWork;
